import { useState } from "react";
import { toast } from "sonner";
import { Download, Upload } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { download } from "@/lib/accounting";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const ContactsImport = ({ onDone }) => {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [rep, setRep] = useState(null);
  const run = async () => {
    const fd = new FormData();
    fd.append("file", file);
    try { const { data } = await api.post("/parties/contacts-import", fd); setRep(data); onDone(); toast.success("Contatti aggiornati"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mb-4 flex flex-wrap gap-2">
      <Button variant="outline" onClick={() => download("/parties/contacts-template", {}, "modello-contatti-clienti-fornitori.xlsx")} data-testid="contacts-template-button"><Download className="mr-1 h-4 w-4" />Scarica modello contatti</Button>
      <Button variant="outline" onClick={() => { setRep(null); setFile(null); setOpen(true); }} data-testid="contacts-import-button"><Upload className="mr-1 h-4 w-4" />Importa contatti da Excel</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="contacts-import-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl">Importa email, PEC e telefoni</DialogTitle></DialogHeader>
          <p className="text-sm text-muted-foreground">Usa il modello scaricabile, già compilato con tutte le anagrafiche. Le anagrafiche si riconoscono dalla P.IVA (poi codice fiscale o ragione sociale). Le celle vuote non cancellano i dati esistenti. Puoi indicare anche condizioni di pagamento, IBAN e reverse charge.</p>
          <Input type="file" accept=".xlsx,.xlsm" onChange={(e) => setFile(e.target.files[0])} data-testid="contacts-import-file" />
          <Button disabled={!file} onClick={run} data-testid="contacts-import-submit">Importa</Button>
          {rep && (
            <div className="max-h-60 overflow-y-auto border bg-muted/40 p-3 text-sm" data-testid="contacts-import-report">
              <div><strong>{rep.updated}</strong> aggiornate · {rep.unchanged} invariate · {rep.not_found.length} non trovate · {rep.errors.length} errori</div>
              <ul className="mt-2 list-disc pl-5 text-xs">
                {rep.not_found.map((x) => <li key={`n${x.row}`}>Riga {x.row} {x.name}: {x.reason}</li>)}
                {rep.errors.map((x, i) => <li key={`e${i}`} className="text-red-700">Riga {x.row} {x.name}: {x.error}</li>)}
              </ul>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};
